// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "dc07ed8c" + "." + "fc699a480df62fe9" + ".js";
};